module.exports = __webpack_public_path__ + "media/images/icons/heart-2fff92f0934d7a20ad70a8af7278f95e.svg";